import { createFeature, createReducer, on } from '@ngrx/store';
import { CheckboxTreeNode } from '@emi/shared/models';
import * as checkboxActions from './checkbox-actions';

export interface CheckboxState {
    checkboxes: CheckboxTreeNode[];
}

export const checkboxFeatureKey = 'checkbox';

const initialState: CheckboxState = {
    checkboxes: [],
};

export const checkboxFeature = createFeature({
    name: checkboxFeatureKey,
    reducer: createReducer(
        initialState,
        on(checkboxActions.updateCheckboxes, (state, { checkbox }) => {
            let selectedCheckboxes: Array<CheckboxTreeNode> = [...state.checkboxes];
            if (checkbox.state === 'unchecked') {
                selectedCheckboxes = selectedCheckboxes.filter((x) => `${x.id}:${x.industryCode}` !== `${checkbox.id}:${checkbox.industryCode}`);
            } else {
                selectedCheckboxes = selectedCheckboxes.filter((x) => `${x.id}:${x.industryCode}` !== `${checkbox.id}:${checkbox.industryCode}`);
                selectedCheckboxes.push(checkbox);
            }
            return {
                ...state,
                checkboxes: selectedCheckboxes,
            };
        }),
        on(checkboxActions.setCheckboxes, (state, { checkboxes }) => {
            const selectedCheckboxes: Array<CheckboxTreeNode> = checkboxes;

            return {
                ...state,
                checkboxes: selectedCheckboxes,
            };
        }),
        on(checkboxActions.clearCheckboxes, (state) => {
            return {
                ...state,
                checkboxes: [],
            };
        })
    ),
});
